import SharePrimary2020 from '@svg/trip/share_primary_20_20.svg';
import ArrowRightPoint300128 from '@svg/trip/arrow_right_point_300_12_8.svg';

interface TripHeaderProps {
  isEditRole: boolean;
  startAndEndDate: {
    start: string;
    end: string;
    range: number;
  } | null;
  onClickModifySurveyDate: () => void;
  onClickTripShare: () => void;
}

export default function TripHeader({
  isEditRole,
  startAndEndDate,
  onClickTripShare,
  onClickModifySurveyDate,
}: TripHeaderProps) {
  return (
    <>
      <div className={`flex items-end justify-between ${isEditRole && 'pt-10pxr'} pb-24pxr px-20pxr gap-10pxr`}>
        <div className='flex flex-col items-start'>
          {isEditRole && (
            <button
              className='flex gap-2pxr items-center text-new-point-500 body-14-md'
              onClick={onClickModifySurveyDate}
            >
              일정편집
              <span className='w-20pxr h-20pxr flex items-center justify-center'>
                <ArrowRightPoint300128 />
              </span>
            </button>
          )}
          <div className='flex items-center gap-8pxr'>
            <span className='text-new-gray-900 body-16-md line-clamp-1'>
              {startAndEndDate?.start === startAndEndDate?.end
                ? startAndEndDate?.start
                : `${startAndEndDate?.start} ~ ${startAndEndDate?.end}`}
            </span>
            <span className='text-new-point-400 body-12-bold px-5pxr py-3pxr border border-new-point-200 bg-white rounded-4pxr h-24pxr flex-none'>
              {startAndEndDate?.range === 0
                ? '당일치기'
                : `${startAndEndDate?.range}박 ${(startAndEndDate?.range || 0) + 1}일`}
            </span>
          </div>
        </div>
        <button
          className='flex items-center text-new-point-500 sub-heading-14-m w-89pxr h-20pxr justify-between flex-none'
          onClick={onClickTripShare}
        >
          <SharePrimary2020 className='flex-none' />
          일정표 공유
        </button>
      </div>
      <div className='w-full h-10pxr bg-gray-100 border-t border-b border-gray-300'></div>
    </>
  );
}
